import { Auth } from 'aws-amplify'


class Payment  {
	constructor(request) {
		this.request = request
		this.endpoint = 'payment'
	}

	async Submit(info) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})

		return this.request.send(
			`${this.endpoint}/webform/submit`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
				"configkey":"618f4670ee72f6e9f11c42fdcc1c3da6"
			}
		)
	}

	async RequestQR(info) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})
		return this.request.send(
			`${this.endpoint}/qrph/hitpay`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
			}
		)
	}

	async QRStatus(requestid) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})
		return this.request.send(
			`${this.endpoint}/status/hitpay`,
			'POST',
			{requestid},
			jwtToken,
			undefined,
			{
			}
		)
	}

	async GetHistory(username, type="payment", statusFilter="", pageOffset=0) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})
		const body = {
			username:username,
			statusfilter:statusFilter,
			pageoffset:pageOffset,
			type:type
		};
		return this.request.send(
			`${this.endpoint}/list`,
			'POST',
			body,
			jwtToken
		)
	}

}

export default Payment
